import React from "react";
import styled from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// Drop Down
import { DropDownProvider, Hotspot } from "core/DropDown/index.js";

// data
import { primaryMenu } from "data/links";

// components
import SrOnly from "core/SrOnly";
import EllipsesHorizontal from "core/ReusableIcons/EllipsesHorizontal.js";
import DropDown from "./DropDown";

// styles
import colors from "core/colors";
import { easingSeconds } from "core/animation";
import { convertPxToRem } from "frontend/components/helpers";

const TheNounProjectStyled = styled.div`
    display: inline-block;
    margin: 0rem 0rem 0rem ${convertPxToRem(8)};
`;

const HostSpotStyled = styled(Hotspot)`
    width: ${convertPxToRem(24)};
    height: ${convertPxToRem(24)};
    border-radius: 50%;

    transition: background-color ${easingSeconds} ease-in-out;
    background-color: ${({ $isDarkMode }) =>
        $isDarkMode ? colors.secondary.orca : colors.primary.snow};

    &:hover {
        background-color: ${({ $isDarkMode }) =>
            $isDarkMode ? colors.secondary.basalt : colors.primary.scheifer};
    }

    /*
        To ensure this SVG lines up with it's textual counterparts (e.g. API Tools)
        For some reason the shared styles do not work here with SVG
        Potentially something to do with line-spacing, font-size, something with the SVG.
    */
    position: relative;
    top: ${convertPxToRem(3)};
    svg {
        position: relative;
        top: ${convertPxToRem(2)};
    }
`;

// component
export const TheNounProject = () => {
    const { isDarkMode } = useSiteHeader();
    return (
        <TheNounProjectStyled>
            <DropDownProvider
                id="tnp-menu"
                isDarkMode={isDarkMode}
                hasCloseButton={false}
                hideOnScroll
                width={185}
                top={5}
                zIndex={2}
            >
                <HostSpotStyled $isDarkMode={isDarkMode}>
                    <SrOnly>{primaryMenu.tnp.name}</SrOnly>
                    <EllipsesHorizontal
                        size={{ width: 20, height: 20 }}
                        fillColor={
                            isDarkMode
                                ? colors.primary.diamond
                                : colors.secondary.orca
                        }
                    />
                </HostSpotStyled>
                <DropDown />
            </DropDownProvider>
        </TheNounProjectStyled>
    );
};

export default TheNounProject;
